'use client'

import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useAuth } from '@/providers/AuthContext'
import { getMe } from '@/services/users/me'
import type { AdminUserDetail } from '@/services/admin/users'

/**
 * `['users','me','events']` (`useUserEvents.ts`, modo `self`) é PREFIXO-FILHA
 * de `me`: invalidar o perfil também invalida a trilha. É intencional — editar
 * nome/e-mail/avatar GERA linha de evento, então refetchar a própria trilha
 * de eventos junto é correto (Divergência 4 do plano de identidade-atendente).
 */
export const meKeys = {
  me: ['users', 'me'] as const,
  events: ['users', 'me', 'events'] as const,
}

/** `GET /users/me` — auto-edição, sem exigir `users:read`. Não dispara sem
 *  user carregado (pré-`/auth/me`, ou pós-logout). */
export function useMe(): UseQueryResult<AdminUserDetail> {
  const { user } = useAuth()
  return useQuery({
    queryKey: meKeys.me,
    queryFn: getMe,
    enabled: Boolean(user),
  })
}
